import React from "react"
import { Link } from "@tanstack/react-router"

declare const __GIT_COMMIT_SHA__: string
declare const __GIT_BRANCH__: string
declare const __GIT_COMMIT_DATE__: string

interface FooterLink {
  title: string
  slug: string
}

export function Footer({ footerLinks = [], pathPrefix = "", isAdmin = false }: { footerLinks?: FooterLink[]; pathPrefix?: "" | "/admin"; isAdmin?: boolean }) {
  return (
    <footer className="flex h-10 shrink-0 items-center justify-between border-t bg-background px-6 text-xs text-muted-foreground">
      <span>Copyright © 2026 by Specia</span>
      {isAdmin && (
        <span>
          {__GIT_BRANCH__} @ {__GIT_COMMIT_SHA__}
          {__GIT_COMMIT_DATE__ && (() => {
            const d = new Date(__GIT_COMMIT_DATE__)
            return ` · ${d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })} ${d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })}`
          })()}
        </span>
      )}
      <div className="flex items-center gap-4">
        {footerLinks.map((link) => (
          <Link
            key={link.slug}
            to={`${pathPrefix}/pages/$slug`}
            params={{ slug: link.slug }}
            className="hover:text-foreground transition-colors"
          >
            {link.title}
          </Link>
        ))}
        <a href="https://form.jotform.com/260154630481148" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">Feedback</a>
      </div>
    </footer>
  )
}
